<template>
    <el-container style="height: 100%">
        <el-header style="height: 30px">
            <van-nav-bar title="店销信息" left-text="返回" left-arrow @click-left="historyBackPath('intebotab')"/>
        </el-header>
        <el-main style="height: 100%">
            <el-form :inline="true" :model="searchParms" size="mini">
                <el-form-item label="品牌门店">
                    <el-cascader :options="storeData" clearable filterable v-model="searchParms.storeStructs" :props="{ checkStrictly: true }" size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                </el-form-item>
                <el-form-item label="总监">
                    <el-select v-model="searchParms.staffid" placeholder="请选择" style="width: 120px" filterable default-first-option clearable @change="headerChange">
                        <el-option v-for="(item,key) in staffData" :value="item.staffid" :label="item.staffname" :key="key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期">
                    <el-date-picker style="width: 210px"
                                    value-format="yyyy-MM-dd"
                                    size="mini"
                                    v-model="pickerData"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    :clearable="false"
                                    @change="headerChange"
                                    :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="openAdd()" size="mini">新增</el-button>
                </el-form-item>
            </el-form>
            <el-table height="calc(100% - 4rem)" border :data="inteboStoreSaleData" v-loadmore="loadmore" style="text-align: center" highlight-current-row>
                <el-table-column label="门店"  align="center" prop="storename">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.parentname}}/{{scope.row.inteboStoreSale.storename}}
                    </template>
                </el-table-column>
                <el-table-column label="店销类型"  align="center" prop="saletype">
                    <template slot-scope="scope">
                        <div style="color: #409eff" v-if="scope.row.inteboStoreSale.saletype==1">新店</div>
                        <div style="color: red"     v-if="scope.row.inteboStoreSale.saletype==2">复打</div>
                    </template>
                </el-table-column>
                <el-table-column label="开始日期"  align="center" prop="fromdate">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.fromdate}}
                    </template>
                </el-table-column>
                <el-table-column label="结束日期"  align="center" prop="todate">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.todate}}
                    </template>
                </el-table-column>
                <el-table-column label="市场总监"  align="center" prop="header">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.headername}}
                    </template>
                </el-table-column>
                <el-table-column label="操作总监"  align="center" prop="header">
                    <template slot-scope="scope">
                        <div v-for="(item,key) in scope.row.inteboSsOperations" :key="key">{{item.staffname}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="销售天数"  align="center" prop="saleday">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.saleday}}
                    </template>
                </el-table-column>
                <el-table-column label="体验人数"  align="center" prop="tynumber">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.tynumber}}
                    </template>
                </el-table-column>
                <el-table-column label="成交人数"  align="center" prop="dealnumber">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.dealnumber}}
                    </template>
                </el-table-column>
                <el-table-column label="未成交"  align="center" prop="notnumber">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.notnumber}}
                    </template>
                </el-table-column>
                <el-table-column label="目标业绩"  align="center" prop="targerperf">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.targerperf}}
                    </template>
                </el-table-column>
                <el-table-column label="现金业绩"  align="center" prop="realperf">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.realperf}}
                    </template>
                </el-table-column>
                <el-table-column label="回款金额"  align="center" prop="backamount">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.backamount}}
                    </template>
                </el-table-column>
                <el-table-column label="备注"  align="center" prop="remarks">
                    <template slot-scope="scope">
                        {{scope.row.inteboStoreSale.remarks}}
                    </template>
                </el-table-column>
                <el-table-column label="结账状态"  align="center" prop="finished">
                    <template slot-scope="scope">
                        <div style="color: #409eff" v-if="scope.row.inteboStoreSale.finished==0">未结账</div>
                        <div style="color: red" v-if="scope.row.inteboStoreSale.finished==1">已结账</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作"  align="center" width="100" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="openUpdateStoreSale(scope.row)" type="text">修改</el-button>
                        <el-button @click="getInteboCheckOutBySysbillid(scope.row.inteboStoreSale.sysbillid)" type="text">账单</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-main>
        <el-dialog title="结账单信息" :visible.sync="dialogVisible" width="100%" top="0px" @close="dialogVisible=false" class="checkclass"
                   :close-on-press-escape="false" :close-on-click-modal="false">
            <el-descriptions direction="vertical" :column="11" border v-if="checkOut.mthamount>0" style="margin-bottom: 20px">
                <template slot="extra">
                    <el-button type="primary" size="small" @click="openUpdate(checkOut)" v-if="checkOut.finished!=1">修改</el-button>
                    <el-button type="danger" size="small" :loading="queryLoadBtton" v-if="checkOut.finished!=1" @click="inteboCheckOutFinished(checkOut)">结账</el-button>
                </template>
                <el-descriptions-item label="日期">{{$moment(checkOut.fromdate).format('MM.DD')}}-{{$moment(checkOut.todate).format('MM.DD')}}</el-descriptions-item>
                <el-descriptions-item label="企业名称">{{checkOut.storename}}</el-descriptions-item>
                <el-descriptions-item label="门店业绩"><span style="color: red">{{checkOut.perf}}</span></el-descriptions-item>
                <el-descriptions-item :label="checkOut.title">
                    <span style="color: red">{{checkOut.backamount}}</span>
                </el-descriptions-item>
                <el-descriptions-item label="本月月供"><span style="color: red">{{Math.round(checkOut.mthamount)}}</span></el-descriptions-item>
                <el-descriptions-item label="仪器总额"><span style="color: red">{{checkOut.yqamount}}</span></el-descriptions-item>
                <el-descriptions-item label="已收款"><span style="color: red">{{Math.round(checkOut.realamount)}}</span></el-descriptions-item>
                <el-descriptions-item label="剩余款项金"><span style="color: red">{{Math.round(checkOut.restamount)}}</span></el-descriptions-item>
                <el-descriptions-item :label="'剩余分'+checkOut.restfq+'期金额'" v-show="Math.round(checkOut.mthamount)>0"><span style="color: red">{{Math.round(checkOut.mthamount)}}</span></el-descriptions-item>
                <el-descriptions-item label="是否到账">
                    <span style="color: red" v-if="checkOut.finished==1">已结账</span>
                    <span style="color: #409eff" v-if="checkOut.finished==0">未结账</span>
                </el-descriptions-item>
                <el-descriptions-item label="负责总监">{{checkOut.header}}</el-descriptions-item>
                <el-descriptions-item label="回款信息">
                    {{checkOut.storename}}:本次应打回款:<span style="color: red">{{Math.round(checkOut.backamount)}}+{{Math.round(checkOut.mthamount)}}={{Math.round(checkOut.backamount)+Math.round(checkOut.mthamount)}}</span>
                    剩余仪器款:<span style="color: red">{{Math.round(checkOut.restamount)}}</span>元，剩余{{checkOut.restfq}}期分期金额:<span style="color: red">{{Math.round(checkOut.mthamount)}}</span>
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions direction="vertical" :column="9" border v-if="checkOut.mthamount<1">
                <template slot="extra">
                    <el-button type="primary" size="small" @click="openUpdate(checkOut)" v-if="checkOut.finished!=1">修改</el-button>
                    <el-button type="danger" size="small" :loading="queryLoadBtton" v-if="checkOut.finished!=1" @click="inteboCheckOutFinished(checkOut)">结账</el-button>
                </template>
                <el-descriptions-item label="日期">{{$moment(checkOut.fromdate).format('MM.DD')}}-{{$moment(checkOut.todate).format('MM.DD')}}</el-descriptions-item>
                <el-descriptions-item label="企业名称">{{checkOut.storename}}</el-descriptions-item>
                <el-descriptions-item label="门店业绩"><span style="color: red">{{checkOut.perf}}</span></el-descriptions-item>
                <el-descriptions-item :label="checkOut.title">
                    <span style="color: red">{{checkOut.backamount}}</span>
                </el-descriptions-item>
                <el-descriptions-item label="仪器总额"><span style="color: red">{{checkOut.yqamount}}</span></el-descriptions-item>
                <el-descriptions-item label="已收款"><span style="color: red">{{Math.round(checkOut.realamount)}}</span></el-descriptions-item>
                <el-descriptions-item label="剩余款项金"><span style="color: red">{{Math.round(checkOut.restamount)}}</span></el-descriptions-item>
                <el-descriptions-item label="是否到账">
                    <span style="color: red" v-if="checkOut.finished==1">已结账</span>
                    <span style="color: #409eff" v-if="checkOut.finished==0">未结账</span>
                </el-descriptions-item>
                <el-descriptions-item label="负责总监">{{checkOut.header}}</el-descriptions-item>
                <el-descriptions-item label="回款信息">
                    {{checkOut.storename}}:本次应打回款:<span style="color: red">{{Math.round(checkOut.backamount)}}</span>
                    剩余仪器款:<span style="color: red">{{Math.round(checkOut.restamount)}}</span>元.
                </el-descriptions-item>
            </el-descriptions>
        </el-dialog>
        <el-dialog title="修改结账单" :visible.sync="updateDialogVisible" width="100%" top="0px" @close="updateDialogVisible=false" class="checkclass"
                   :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form :model="checkOut" label-width="100px">
                <el-form-item label="品牌门店">
                    {{checkOut.parentname}}/{{checkOut.storename}}
                </el-form-item>
                <el-form-item label="日期">
                    {{checkOut.fromdate}}到{{checkOut.todate}}
                </el-form-item>
                <el-form-item label="门店业绩">
                    {{checkOut.perf}}
                </el-form-item>
                <el-form-item :label="checkOut.title">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.backamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="本月月供">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.mthamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="仪器总额">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.yqamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="已收款">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.realamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="剩余款项金">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.restamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="剩余分期">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.restfq">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="负责总监">
                    {{checkOut.header}}
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updateDialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="queryLoadBtton" size="mini" @click="updateInteboCheckOut()">保存</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            queryLoadBtton:false,
            updateDialogVisible:false,
            dialogVisible:false,
            checkOut:{},
            isFinite:false,
            curpage:1,
            inteboStoreSaleData:[],
            staffData:[],
            searchParms:{
                parentid:"",
                storeid:"",
                staffid:"",
            },
            storeData:[],
            pickerData:[
                this.$moment().startOf('month').format('YYYY-MM-DD'),
                this.$moment().endOf('month').format('YYYY-MM-DD')
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick:(picker)=> {
                            const start=this.$moment().format('YYYY-MM-DD');
                            picker.$emit('pick', [start, start]);
                        }
                    },
                    {
                        text: '昨天',
                        onClick:(picker)=> {
                            const start=this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, start]);
                        }
                    },
                    {
                        text: '本周',
                        onClick:(picker)=> {
                            const start=this.$moment().startOf('week').add(1, 'days').format('YYYY-MM-DD');
                            const end =this.$moment().endOf('week').add(1, 'days').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '上一周',
                        onClick:(picker)=>{
                            const start=this.$moment().startOf('week').subtract(6, 'days').format('YYYY-MM-DD');
                            const end =this.$moment().endOf('week').subtract(6, 'days').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '本月',
                        onClick:(picker)=>{
                            const start=this.$moment().startOf('month').format('YYYY-MM-DD');
                            const end =this.$moment().endOf('month').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '上个月',
                        onClick:(picker)=> {
                            const start=this.$moment(this.$moment().format('YYYY-MM-')+'01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                            const num=this.$moment(start, "YYYY-MM-DD").daysInMonth();
                            picker.$emit('pick', [start+'-01', start+'-'+num]);
                        }
                    },
                ],
            },
        }
    },
    created() {
        this.getInteboStoreStructs();
        this.getInteboStaffTrain();
        this.getInteboStoreSalePage();
    },
    methods:{
        inteboCheckOutFinished(item){
            this.$confirm("你确定该结账单是否正确吗？","提示",{
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.queryLoadBtton=true;
                this.$postw("intebosale/inteboCheckOutFinished",item).then(res=>{
                    this.queryLoadBtton=false;
                    if(res.sucess){
                        this.dialogVisible=false;
                        this.queryLoadBtton=false;
                        this.$message({message: "保存成功", type: 'success'});
                    }
                });
            });
        },
        openUpdate(){
            this.updateDialogVisible=true;
        },
        updateInteboCheckOut(){
            this.queryLoadBtton=true;
            let totalamount=this.$addNumber(this.checkOut.backamount,this.checkOut.mthamount);
            totalamount=this.$addNumber(this.checkOut.restamount,totalamount);
            if(totalamount!=this.checkOut.qyamount){
                this.$message({message: "支付金额+剩余金额不等于仪器总金额", type: 'error'});
                this.queryLoadBtton=false;
                return;
            }
            this.$postw("intebosale/updateInteboCheckOut",this.checkOut).then(res=>{
                this.queryLoadBtton=false;
                if(res.sucess){
                    this.updateDialogVisible=false;
                    this.dialogVisible=false;
                    this.$message({message: "保存成功", type: 'success'});
                }
            });
        },
        getInteboCheckOutBySysbillid(sysbillid){
            this.dialogVisible=true;
            this.$post("intebosale/getInteboCheckOutBySysbillid",{sysbillid:sysbillid}).then(res=>{
                if(res.sucess){
                    this.checkOut=res.object;
                }
            });
        },
        openAdd(){
            this.$router.push({path:'/addintebostoresale'});
        },
        loadmore(){
            if(this.isFinite==false){
                this.curpage++;
                this.getInteboStoreSalePage();
            }
        },
        openUpdateStoreSale(row){
            this.$router.push({path:'/addintebostoresale',query:{
                    sysbillid:row.inteboStoreSale.sysbillid,
                    type:'update'
                }});
        },
        headerChange(val){
            this.isFinite=false;
            this.inteboStoreSaleData=[];
            this.curpage=1;
            this.getInteboStoreSalePage();
        },
        storeChange(val){
            this.searchParms.parentid="";
            this.searchParms.storeid="";
            if(val[0]){
                this.searchParms.parentid=val[0];
            }
            if(val[1]){
                this.searchParms.storeid=val[1];
            }
            this.isFinite=false;
            this.inteboStoreSaleData=[];
            this.curpage=1;
            this.getInteboStoreSalePage();
        },
        getInteboStoreSalePage(){
            let fromdate=this.pickerData[0];
            let todate=this.pickerData[1];
            this.$post("intebosale/getInteboStoreSalePage",{parentid:this.searchParms.parentid,storeid:this.searchParms.storeid,staffid:this.searchParms.staffid,
            fromdate:fromdate,todate:todate,curpage:this.curpage}).then(res=>{
                if(res.sucess){
                    let obj=res.object;
                    if(obj!=null && obj.length>0){
                        for(let val of obj){
                            this.inteboStoreSaleData.push(val);
                        }
                    }
                    else{
                        this.isFinite=true;
                    }
                }
            });
        },
        getInteboStaffTrain(){
            this.$post("inteboStaff/getInteboStaffTrain").then(res=>{
                if(res.sucess){
                    this.staffData=res.object;
                }
            });
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        }
    }
}
</script>

<style style lang="scss" rel="stylesheet/scss">
.checkclass .el-input-number .el-input__inner{
    text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/page/intebo/intebotab/intebostoresale.vue